import type { ApiClient } from '@revolugo/booking-api-client'
import type { ApiVersion } from '@revolugo/common/constants'
import type { IEventBus, RevolugoConfig } from '@revolugo/elements-vue3'

export const updateConfig = (config: Partial<RevolugoConfig>): void => {
  if (!window) {
    return
  }

  window.RevolugoElements = window.RevolugoElements || {
    bookingApiClient: undefined as unknown as ApiClient<ApiVersion.V1>,
    config: undefined as unknown as RevolugoConfig,
    eventBus: undefined as unknown as IEventBus,
    ready: () => {
      // No-op function for initialization
    },
  }

  window.RevolugoElements.config = {
    ...window.RevolugoElements.config,
    ...config,
  }
}
